export default __webpack_public_path__ + "static/media/notfound.d21d5c71.png";